module.exports = __webpack_public_path__ + "img/Barnsley-Service-logo-Square-Oct-2020.67ee7269.png";